import DefaultLayout from "@/layouts/DefaultLayout.vue"; // Import DefaultLayout

import MakerCartPage from "../views/MakerCart/MakerCartPage.vue";
import MakerCartGuidePage from "../views/MakerCartGuide/MakerCartGuidePage.vue";
import MakerCartGuide1Page from "../views/MakerCartGuide/MakerCartGuide1Page.vue";
import MakerCartGuide2Page from "../views/MakerCartGuide/MakerCartGuide2Page.vue";
import MakerCartGuide3Page from "../views/MakerCartGuide/MakerCartGuide3Page.vue";
import MakerCartGuide4Page from "../views/MakerCartGuide/MakerCartGuide4Page.vue";
import MakerCartGuide5Page from "../views/MakerCartGuide/MakerCartGuide5Page.vue";
import MakerCartGuide6Page from "../views/MakerCartGuide/MakerCartGuide6Page.vue";
import MakerCartGuide7Page from "../views/MakerCartGuide/MakerCartGuide7Page.vue";
import MakerCartGuide8Page from "../views/MakerCartGuide/MakerCartGuide8Page.vue";
import MakerCartGuide9Page from "../views/MakerCartGuide/MakerCartGuide9Page.vue";
import MakerCartGuide10Page from "../views/MakerCartGuide/MakerCartGuide10Page.vue";
import MakerCartGuide11Page from "../views/MakerCartGuide/MakerCartGuide11Page.vue";
import MakercartGetStartedPage from "@/views/MakerCart/MakerCartGetStartedPage.vue";
import MakerCartCartPage from "@/views/MakerCart/MakerCartCartPage.vue";
import MakercrateInstantCheckoutPage from "@/views/MakerCart/MakercrateInstantCheckoutPage.vue";

const makerCartRoutes = [
  {
    path: "/makercart-studio",
    redirect: "/makercart/catalog",
  },
  {
    path: "/makercart",
    component: DefaultLayout,
    meta: { requiresAuth: false },
    children: [
      {
        path: "get-started",
        name: "MakerCartGetStartedPage",
        component: MakercartGetStartedPage,
        meta: { requiresAuth: false, title: "Makercart Get Started" },
      },
      {
        path: "cart",
        name: "MakerCartCartPage",
        component: MakerCartCartPage,
        meta: { requiresAuth: false, title: "Cart" },
      },
      {
        path: "instant-checkout",
        name: "MakercrateInstantCheckoutPage",
        component: MakercrateInstantCheckoutPage,
        meta: { requiresAuth: false, title: "Instant Checkout" },
      },
      {
        path: "catalog",
        name: "MakerCartPage",
        component: MakerCartPage,
        meta: { requiresAuth: false, title: "Makercart" },
      },
    ],
  },
  {
    path: "/makercart/guide",
    component: DefaultLayout,
    meta: { requiresAuth: false },
    children: [
      {
        path: "",
        name: "MakerCartGuidePage",
        component: MakerCartGuidePage,
        meta: {
          requiresAuth: false,
          title: "Makercart Guide",
          requiresEducatorsGuide: true,
        },
      },
      {
        path: "1",
        name: "MakerCartGuide1Page",
        component: MakerCartGuide1Page,
        meta: {
          requiresAuth: false,
          title: "Makercart Guide",
          requiresEducatorsGuide: true,
        },
      },
      {
        path: "2",
        name: "MakerCartGuide2Page",
        component: MakerCartGuide2Page,
        meta: {
          requiresAuth: false,
          title: "Makercart Guide",
          requiresEducatorsGuide: true,
        },
      },
      {
        path: "3",
        name: "MakerCartGuide3Page",
        component: MakerCartGuide3Page,
        meta: {
          requiresAuth: false,
          title: "Makercart Guide",
          requiresEducatorsGuide: true,
        },
      },
      {
        path: "4",
        name: "MakerCartGuide4Page",
        component: MakerCartGuide4Page,
        meta: {
          requiresAuth: false,
          title: "Makercart Guide",
          requiresEducatorsGuide: true,
        },
      },
      {
        path: "5",
        name: "MakerCartGuide5Page",
        component: MakerCartGuide5Page,
        meta: {
          requiresAuth: false,
          title: "Makercart Guide",
          requiresEducatorsGuide: true,
        },
      },
      {
        path: "6",
        name: "MakerCartGuide6Page",
        component: MakerCartGuide6Page,
        meta: {
          requiresAuth: false,
          title: "Makercart Guide",
          requiresEducatorsGuide: true,
        },
      },
      {
        path: "7",
        name: "MakerCartGuide7Page",
        component: MakerCartGuide7Page,
        meta: {
          requiresAuth: false,
          title: "Makercart Guide",
          requiresEducatorsGuide: true,
        },
      },
      {
        path: "8",
        name: "MakerCartGuide8Page",
        component: MakerCartGuide8Page,
        meta: {
          requiresAuth: false,
          title: "Makercart Guide",
          requiresEducatorsGuide: true,
        },
      },
      {
        path: "9",
        name: "MakerCartGuide9Page",
        component: MakerCartGuide9Page,
        meta: {
          requiresAuth: false,
          title: "Makercart Guide",
          requiresEducatorsGuide: true,
        },
      },
      {
        path: "10",
        name: "MakerCartGuide10Page",
        component: MakerCartGuide10Page,
        meta: {
          requiresAuth: false,
          title: "Makercart Guide",
          requiresEducatorsGuide: true,
        },
      },
      {
        path: "11",
        name: "MakerCartGuide11Page",
        component: MakerCartGuide11Page,
        meta: {
          requiresAuth: false,
          title: "Makercart Guide",
          requiresEducatorsGuide: true,
        },
      },
    ],
  },
];

export default makerCartRoutes;
